import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-10" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", { class: "anchor fw-bolder mb-5" }, [
  /*#__PURE__*/_createVNode("a", { href: "#grouping-table-head" }),
  /*#__PURE__*/_createTextVNode(" Grouping table head ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "py-5" }, " When the data structure is complex, you can use group header to show the data hierarchy. ", -1)
const _hoisted_4 = { class: "rounded border p-10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_table = _resolveComponent("el-table")
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode("div", _hoisted_4, [
      _createVNode(_component_el_table, {
        data: _ctx.tableData,
        style: {"width":"100%"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            prop: "date",
            label: "Date",
            width: "150"
          }),
          _createVNode(_component_el_table_column, { label: "Delivery Info" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                prop: "name",
                label: "Name",
                width: "120"
              }),
              _createVNode(_component_el_table_column, { label: "Address Info" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, {
                    prop: "state",
                    label: "State",
                    width: "120"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "city",
                    label: "City",
                    width: "120"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "address",
                    label: "Address"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "zip",
                    label: "Zip",
                    width: "120"
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"]),
      _createVNode(_component_CodeHighlighter, {
        "field-height": 400,
        lang: "html"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.code9), 1)
        ]),
        _: 1
      })
    ])
  ]))
}